import axios from "axios";
import {
  GETINTRESTEDCANDIDATE,
  CREATE_INTRESTED_CANDIDATE_REQUEST,
  CREATE_INTRESTED_CANDIDATE_SUCCESS,
  CREATE_INTRESTED_CANDIDATE_FAIL,
  UPDATEINTRESTEDCANDIDATE,
  DELETEINTRESTEDCANDIDATE,
  baseURL,
} from "./type";

// export const createintrestedcandidate = (data) => (dispatch) => {
//   console.log("Sending FormData..."); // Confirm log

//   // Check if token exists
//   const token = localStorage.getItem("token");

//   var config = {
//     method: "post",
//     url: baseURL + "/api/electionintrestedcandidates/registercandidate",
//     headers: {
//       Authorization: `Bearer ${token}`,

//     },
//     data: data,
//   };

//   axios(config)
//     .then(function (response) {
//       console.log("Success:", response.data);
//       dispatch({
//         type: CREATEINTRESTEDCANDIDATE,
//         payload: response.data,
//       });
//     })
//     .catch(function (error) {
//       console.log("Error details:", error.response ? error.response.data : error.message);
//     });
// };
export const createintrestedcandidate = (data) => async (dispatch) => {
  console.log("Sending FormData..."); // Confirm log

  try {
    // 1. Request सुरू झाली हे सांगण्यासाठी (Loading State साठी)
    dispatch({ type: CREATE_INTRESTED_CANDIDATE_REQUEST });

    // Check if token exists
    const token = localStorage.getItem("token");

    // Config setup
    const config = {
      method: "post",
      url: baseURL + "/api/electionintrestedcandidates/registercandidate",
      headers: {
        Authorization: `Bearer ${token}`,
        // FormData असल्यामुळे Content-Type browser आपोआप सेट करेल
      },
      data: data,
    };

    // 2. API Call (Axios)
    const response = await axios(config);

    // 3. Success (जर डेटा व्यवस्थित सेव्ह झाला)
    dispatch({
      type: CREATE_INTRESTED_CANDIDATE_SUCCESS,
      payload: response.data,
    });

  } catch (error) {

    console.log("Error in Action:", error.response);

    dispatch({
      type: CREATE_INTRESTED_CANDIDATE_FAIL,
     
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};
export const getintrestedcandidate = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    // url: baseURL + "setupElectionTypes/getAll",
    url: baseURL + "/api/electionintrestedcandidates/getAll",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETINTRESTEDCANDIDATE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateintrestedcandidate = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "patch",
    url: baseURL + "api/electionintrestedcandidates/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      // Note: Agar update me bhi file upload hai to ise bhi multipart/form-data karein
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEINTRESTEDCANDIDATE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteintrestedcandidate = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "api/electionintrestedcandidates/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEINTRESTEDCANDIDATE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};